export const shellPages = [
  { slug: 'overview', path: '/', label: 'Overview', title: 'Overview' },
  { slug: 'system', path: '/system', label: 'Deep Dive', title: 'Deep Dive' },
  { slug: 'demo', path: '/demo', label: 'Demo', title: 'Demo' },
  { slug: 'console', path: '/console', label: 'Console', title: 'Console' },
  { slug: 'login', path: '/login', label: 'Login/Logout', title: 'Login/Logout' },
]
